import {
    applyPublicHeadDescriptor,
} from "@logscord/public-site/adapters/browser";
import {
    DefaultLocale,
    getPublicLocaleFromPath,
} from "../../locales/publicLocales.js";
import {
    createLogscordHeadDescriptor,
} from "@logscord/public-site-config";
import {
    createPublicNoIndexPolicy,
} from "@logscord/public-site/seo";
import {
    PublicSite,
} from "../../publicSite.js";


//////////////////////////////////////////////////
//  PRIVATE APPLICATION HEAD
//////////////////////////////////////////////////


export function applyUnauthorizedSeo(path: string, title: string, description: string) {
    applyPublicHeadDescriptor(createLogscordHeadDescriptor({
        siteUrl       : PublicSite.seoIdentity.url,
        defaultImage  : PublicSite.seoIdentity.defaultImage,
        site          : PublicSite,
        path,
        htmlLang      : getPublicLocaleFromPath(path) ?? DefaultLocale,
        title,
        description,
        canonicalPath : path,
        indexing      : createPublicNoIndexPolicy("private"),
        alternates    : [],
        structuredData: [],
    }));
}
